import React from 'react';

// Default mapping: pattern -> display name
const defaultMapping = [
    { pattern: /localhost|127\.0\.0\.1/, name: 'Localhost Traders' },
    { pattern: /vtraders\./i, name: 'Venkateswara Traders' },
    { pattern: /abagencies\./i, name: 'Abhyudaya  Agencies' },
    { pattern: /vdistributors\./i, name: 'Venkateswara Distributors' },
    { pattern: /evoke\./i, name: 'Evoke Agencies' },
    { pattern: /unnati\./i, name: 'Unnati Traders' },
    // Add more mappings here in future
];

export function getCompanyNameFromUrl(hostname = (typeof window !== 'undefined' ? window.location.hostname : ''), mapping = defaultMapping) {
    if (!hostname) return '';
    for (let m of mapping) {
        try {
            if (m.pattern.test(hostname)) return m.name;
        } catch (e) {
            // if pattern is a string, do simple contains
            if (typeof m.pattern === 'string' && hostname.indexOf(m.pattern) !== -1) return m.name;
        }
    }
    return '';
}

export default function CompanyName({ hostname, mapping, className, style, fallback }) {
    const name = getCompanyNameFromUrl(hostname, mapping) || fallback || '';
    if (!name) return null;
    return (
        <div className={className} style={style}>
            {name}
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/CompanyName.js